import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { TEXTS_VARIABLE } from 'src/app/shared/constants/constants-texts';

@Component({
  selector: 'app-search-desktop',
  templateUrl: './search-desktop.component.html',
  styleUrls: ['./search-desktop.component.scss'],
})
export class SearchDesktopComponent {
  equisLoadingSize: any = 'large';
  @Input() param$!: Observable<any>;
  @Input() data$!: Observable<any>;
  @Output() clickQuestion = new EventEmitter();
  isMobile = false;
  texts = TEXTS_VARIABLE;

  constructor() {}

  click(question: any): void {
    this.clickQuestion.emit(question);
  }
}
